/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getMonthlyCoveragePlanStatusByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');
export const getMonthlyCoveragePlanStatusByIdPayloadRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetMonthlyCoveragePlanStatusById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getMonthlyCoveragePlanStatusByIdIdRegExpTwo)]).optional(),
  "payload": zod.union([zod.number(),zod.string().regex(getMonthlyCoveragePlanStatusByIdPayloadRegExpTwo)]).optional()
});

export type GetMonthlyCoveragePlanStatusById = zod.input<typeof GetMonthlyCoveragePlanStatusById>;
export type GetMonthlyCoveragePlanStatusByIdOutput = zod.output<typeof GetMonthlyCoveragePlanStatusById>;
